module.exports = __webpack_public_path__ + "static/media/home.e94bf1a3.svg";